const Templates = [
    {
        "Name": "Logo Left Aligned",
        "IsDefault": false,
        "Type": "invoices",
        "Document": {
            "Config": {
                "Style": {
                    "paddingTop": "20px",
                    "paddingBottom": "40px",
                    "paddingLeft": "40px",
                    "paddingRight": "40px"
                },
                "PDF": {
                    "footer": true,
                    "pageMarginTop": "10",
                    "pageMarginBottom": "10",
                    "pageMarginLeft": "10",
                    "pageMarginRight": "10"
                }
            },
            "Id": "documentSettings"
        },
        "Blocks": [
            {
                "Id": "columnsTwo-default",
                "Type": "columnsTwo",
                "Config": {
                    "Block": {
                        "col1_width": "66",
                        "col2_width": "",
                        "verticalAlign": "top"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px",
                        "minHeight": "50px"
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "logo-default",
                            "Type": "logo",
                            "Config": {
                                "Block": {
                                    "maxWidth": "100%",
                                    "maxHeight": "75px"
                                },
                                "Style": {
                                    "textAlign": "left"
                                }
                            }
                        }
                    ],
                    [
                        {
                            "Id": "companyAddress-default",
                            "Type": "companyAddress",
                            "Config": {
                                "Block": {
                                    "styleCompany": "header",
                                    "colorCompany": "#434343",
                                    "fontSizeCompany": "16px",
                                    "lineHeightCompany": "22px",
                                    "styleAddress": "body",
                                    "colorAddress": "#949494",
                                    "fontSizeAddress": "12px",
                                    "lineHeightAddress": "18px"
                                },
                                "Includes": {
                                    "Company": true,
                                    "Phone": true,
                                    "Website": true
                                },
                                "Style": {
                                    "paddingBottom": "6px",
                                    "textAlign": "right"
                                }
                            }
                        }
                    ]
                ]
            },
            {
                "Id": "separator-default",
                "Type": "separator",
                "Config": {
                    "Block": {
                        "color": "#e9e9e9"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                }
            },
            {
                "Id": "columnsThree-default",
                "Type": "columnsThree",
                "Config": {
                    "Block": {
                        "col1_width": "33",
                        "col2_width": "33",
                        "col3_width": "",
                        "verticalAlign": "top"
                    },
                    "Style": {
                        "paddingBottom": "20px",
                        "minHeight": "50px"
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "address-billing-default",
                            "Type": "address",
                            "Config": {
                                "Block": {
                                    "addressType": "billing",
                                    "styleHeader": "header",
                                    "fontSizeHeader": "16px",
                                    "fontWeightHeader": "bold",
                                    "lineHeightHeader": "19px",
                                    "lineSpacingHeader": "2px",
                                    "textLabelHeader": "Bill To:",
                                    "styleAddress": "body",
                                    "fontSizeAddress": "16px",
                                    "lineHeightAddress": "19px"
                                },
                                "Includes": {
                                    "HeaderLabel": true,
                                    "ContactName": true,
                                    "SpouseName": true,
                                    "Company": true,
                                    "PhoneHome": true,
                                    "PhoneMobile": true,
                                    "PhoneOther": true,
                                    "Email": true
                                },
                                "Style": {
                                    "textAlign": "left"
                                }
                            }
                        }
                    ],
                    [
                        {
                            "Id": "address-shipping-default",
                            "Type": "address",
                            "Config": {
                                "Block": {
                                    "addressType": "shipping",
                                    "styleHeader": "header",
                                    "fontSizeHeader": "16px",
                                    "fontWeightHeader": "bold",
                                    "lineHeightHeader": "19px",
                                    "lineSpacingHeader": "2px",
                                    "textLabelHeader": "Ship To:",
                                    "styleAddress": "body",
                                    "fontSizeAddress": "16px",
                                    "lineHeightAddress": "19px"
                                },
                                "Includes": {
                                    "HeaderLabel": true,
                                    "ContactName": false,
                                    "SpouseName": false,
                                    "Company": false,
                                    "PhoneHome": false,
                                    "PhoneMobile": false,
                                    "PhoneOther": false,
                                    "Email": false
                                },
                                "Style": {
                                    "textAlign": "left"
                                }
                            }
                        }
                    ],
                    [
                        {
                            "Id": "number-default",
                            "Type": "number",
                            "Config": {
                                "Block": {
                                    "displayType": "inline",
                                    "styleLabel": "header",
                                    "fontSizeLabel": "16px",
                                    "fontWeightLabel": "bold",
                                    "lineHeightLabel": "19px",
                                    "textLabel": "Invoice #",
                                    "styleValue": "header",
                                    "fontSizeValue": "16px",
                                    "fontWeightValue": "bold",
                                    "lineHeightValue": "19px",
                                    "textAlignLabel": "right",
                                    "columnWidthValue": "10%",
                                    "textAlignValue": "right",
                                    "columnSpacing": "15px"
                                },
                                "Style": {
                                    "paddingBottom": "2px",
                                    "textAlign": "right"
                                }
                            }
                        },
                        {
                            "Id": "gstTax-default",
                            "Type": "gstTax",
                            "Config": {
                                "Block": {
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "fontWeightValue": "bold",
                                    "lineHeightValue": "19px",
                                    "displayText": "Tax Invoice"
                                },
                                "Style": {
                                    "textAlign": "right"
                                }
                            }
                        },
                        {
                            "Id": "date-default",
                            "Type": "date",
                            "Config": {
                                "Block": {
                                    "displayType": "inline",
                                    "styleLabel": "body",
                                    "fontSizeLabel": "16px",
                                    "lineHeightLabel": "19px",
                                    "textLabel": "Invoice Date: ",
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "lineHeightValue": "19px",
                                    "textAlignLabel": "right",
                                    "columnWidthValue": "10%",
                                    "textAlignValue": "right",
                                    "columnSpacing": "15px"
                                },
                                "Style": {
                                    "textAlign": "right"
                                }
                            }
                        },
                        {
                            "Id": "staff-default",
                            "Type": "staff",
                            "Config": {
                                "Block": {
                                    "displayType": "inline",
                                    "styleLabel": "body",
                                    "fontSizeLabel": "16px",
                                    "lineHeightLabel": "19px",
                                    "textLabel": "Staff: ",
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "lineHeightValue": "19px",
                                    "textAlignLabel": "right",
                                    "columnWidthValue": "10%",
                                    "textAlignValue": "right",
                                    "columnSpacing": "15px"
                                },
                                "Visibility": {
                                    "Staff": true
                                },
                                "Style": {
                                    "textAlign": "right"
                                }
                            }
                        },
                        {
                            "Id": "grandTotal-meta-default",
                            "Type": "grandTotal",
                            "Config": {
                                "Block": {
                                    "displayType": "inline",
                                    "styleLabel": "body",
                                    "fontSizeLabel": "16px",
                                    "fontWeightLabel": "",
                                    "lineHeightLabel": "19px",
                                    "textLabel": "Total Amount: ",
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "fontWeightValue": "bold",
                                    "lineHeightValue": "19px",
                                    "textAlignLabel": "right",
                                    "columnWidthValue": "10%",
                                    "textAlignValue": "right",
                                    "columnSpacing": "15px"
                                },
                                "Style": {
                                    "textAlign": "right"
                                },
                                "Format": {
                                    "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                                }
                            }
                        }
                    ]
                ]
            },
            {
                "Id": "lineItems-default",
                "Type": "lineItems",
                "Config": {
                    "Block": {
                        "styleTableHeader": "header",
                        "fontSizeTableHeader": "16px",
                        "fontWeightTableHeader": "bold",
                        "lineHeightTableHeader": "29px",
                        "lineSpacingTableHeader": "10px",
                        "backgroundColorTableHeader": "#eaeaea",
                        "lineItemSpacing": "15px",
                        "columnSpacing": "10px",
                        "marginLeft": "10px",
                        "marginRight": "5px"
                    },
                    "Meta": {
                        "styleArtist": "body",
                        "fontSizeArtist": "16px",
                        "fontWeightArtist": "bold",
                        "lineHeightArtist": "19px",
                        "styleTitle": "body",
                        "fontSizeTitle": "16px",
                        "lineHeightTitle": "19px",
                        "styleMedium": "body",
                        "fontSizeMedium": "16px",
                        "lineHeightMedium": "19px",
                        "styleDimensions": "body",
                        "fontSizeDimensions": "16px",
                        "lineHeightDimensions": "19px",
                        "styleSKU": "body",
                        "fontSizeSKU": "16px",
                        "lineHeightSKU": "19px",
                        "styleQuantity": "body",
                        "fontSizeQuantity": "16px",
                        "stylePrice": "body",
                        "fontSizePrice": "16px",
                        "styleDiscount": "body",
                        "fontSizeDiscount": "16px",
                        "textZeroDiscount": "0",
                        "styleSubtotal": "body",
                        "fontSizeSubtotal": "16px"
                    },
                    "Includes": {
                        "TableHeader": true,
                        "Date": true,
                        "Medium": true,
                        "Dimensions": true,
                        "Number": false,
                        "SKU": true,
                        "Quantity": true
                    },
                    "Style": {
                        "paddingBottom": "7px"
                    },
                    "Format": {
                        "currencyFormatPriceFirst": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatDiscountFirst": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatSubtotalFirst": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatPrice": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatDiscount": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatSubtotal": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "subtotal-default",
                "Type": "subtotal",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "textLabel": "Subtotal",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "5px"
                    },
                    "Style": {
                        "paddingTop": "9px",
                        "paddingBottom": "6px",
                        "paddingRight": "5px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "discount-default",
                "Type": "discount",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "textLabel": "Discount",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "5px"
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "6px",
                        "paddingRight": "5px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "promoCodes-default",
                "Type": "promoCodes",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "rowSpacing": "11px",
                        "styleDescription": "body",
                        "fontSizeDescription": "14px",
                        "fontStyleDescription": "italic",
                        "lineHeightDescription": "19px",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "lineHeightLabel": "19px",
                        "fontWeightLabel": "bold",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "5px",
                        "fontWeightDescription": "",
                        "columnWidthLabel": "15%"
                    },
                    "Includes": {
                        "Description": true
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "6px",
                        "paddingRight": "5px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "taxes-default",
                "Type": "taxes",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "rowSpacing": "11px",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "5px"
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "6px",
                        "paddingRight": "5px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "shipping-default",
                "Type": "shipping",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "textLabel": "Shipping",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "5px"
                    },
                    "Includes": {
                        "ShippingZero": true
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "6px",
                        "paddingRight": "5px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "grandTotal-default",
                "Type": "grandTotal",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "textLabel": "Grand Total",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "fontWeightValue": "bold",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "5px"
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "6px",
                        "paddingRight": "5px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "payments-default",
                "Type": "payments",
                "Config": {
                    "Block": {
                        "styleHeader": "header",
                        "fontSizeHeader": "16px",
                        "fontWeightHeader": "bold",
                        "lineHeightHeader": "19px",
                        "lineSpacingHeader": "10px",
                        "textLabelHeader": "Payments",
                        "styleTableHeader": "header",
                        "fontSizeTableHeader": "16px",
                        "fontWeightTableHeader": "bold",
                        "lineHeightTableHeader": "19px",
                        "lineSpacingTableHeader": "10px",
                        "styleLineItem": "body",
                        "fontSizeLineItem": "16px",
                        "lineHeightLineItem": "19px",
                        "lineSpacingLineItem": "10px",
                        "methodColumnWidth": "15%",
                        "valueColumnWidth": "15%",
                        "columnSpacing": "10px",
                        "marginRight": "5px"
                    },
                    "Includes": {
                        "HeaderLabel": true,
                        "TableHeader": true,
                        "Method": true,
                        "Refunds": true
                    },
                    "Style": {
                        "paddingTop": "9px",
                        "paddingBottom": "10px"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "credits-default",
                "Type": "credits",
                "Config": {
                    "Block": {
                        "styleHeader": "header",
                        "fontSizeHeader": "16px",
                        "fontWeightHeader": "bold",
                        "lineHeightHeader": "19px",
                        "lineSpacingHeader": "10px",
                        "textLabelHeader": "Credits",
                        "styleTableHeader": "header",
                        "fontSizeTableHeader": "16px",
                        "fontWeightTableHeader": "bold",
                        "lineHeightTableHeader": "19px",
                        "lineSpacingTableHeader": "10px",
                        "styleLineItem": "body",
                        "fontSizeLineItem": "16px",
                        "lineHeightLineItem": "19px",
                        "lineSpacingLineItem": "10px",
                        "methodColumnWidth": "15%",
                        "valueColumnWidth": "15%",
                        "columnSpacing": "10px",
                        "marginRight": "5px"
                    },
                    "Includes": {
                        "HeaderLabel": true,
                        "TableHeader": true,
                        "Method": true
                    },
                    "Style": {
                        "paddingTop": "10px",
                        "paddingBottom": "10px"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "paid-default",
                "Type": "paid",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "textLabel": "Total Paid",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "fontWeightValue": "bold",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "5px"
                    },
                    "Includes": {
                        "NoPayments": true
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "6px",
                        "paddingRight": "5px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "refunded-default",
                "Type": "refunded",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "textLabel": "Total Refunded",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "fontWeightValue": "bold",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "5px"
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "6px",
                        "paddingRight": "5px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "balance-default",
                "Type": "balance",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "textLabel": "Balance",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "fontWeightValue": "bold",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "5px"
                    },
                    "Includes": {
                        "NoPayments": true
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "5px",
                        "paddingRight": "5px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "notes-default",
                "Type": "notes",
                "Config": {
                    "Block": {
                        "styleHeader": "body",
                        "fontSizeHeader": "16px",
                        "fontWeightHeader": "bold",
                        "lineHeightHeader": "19px",
                        "lineSpacingHeader": "16px",
                        "textLabelHeader": "Invoice Comments",
                        "styleNote": "body",
                        "fontSizeNote": "16px",
                        "lineHeightNote": "19px"
                    },
                    "Includes": {
                        "HeaderLabel": true
                    },
                    "Style": {
                        "paddingBottom": "16px",
                        "textAlign": "left"
                    }
                }
            },
            {
                "Id": "signature-default",
                "Type": "signature",
                "Config": {
                    "Block": {
                        "styleSignature": "body",
                        "fontSizeSignature": "16px",
                        "lineHeightSignature": "18px",
                        "labelTextSignature": "Signature:",
                        "styleDate": "body",
                        "fontSizeDate": "16px",
                        "lineHeightDate": "18px",
                        "labelTextDate": "Date:",
                        "dateWidth": "40",
                        "spacing": "80px"
                    },
                    "Includes": {
                        "Date": true
                    },
                    "Style": {
                        "paddingTop": "40px"
                    }
                }
            }
        ],
        "Migration": {
            "includeBalanceNoPayments": true,
            "includePaidNoPayments": true,
            "promoCodes": true
        }
    },
    {
        "Name": "Logo Right Aligned",
        "IsDefault": false,
        "Type": "invoices",
        "Document": {
            "Config": {
                "Style": {
                    "paddingTop": "20px",
                    "paddingBottom": "40px",
                    "paddingLeft": "40px",
                    "paddingRight": "40px"
                },
                "PDF": {
                    "footer": true,
                    "pageMarginTop": "10",
                    "pageMarginBottom": "10",
                    "pageMarginLeft": "10",
                    "pageMarginRight": "10"
                }
            },
            "Id": "documentSettings"
        },
        "Blocks": [
            {
                "Id": "columnsTwo-default",
                "Type": "columnsTwo",
                "Config": {
                    "Block": {
                        "col1_width": "",
                        "col2_width": "66",
                        "verticalAlign": "top"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px",
                        "minHeight": "50px"
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "companyAddress-default",
                            "Type": "companyAddress",
                            "Config": {
                                "Block": {
                                    "styleCompany": "header",
                                    "colorCompany": "#434343",
                                    "fontSizeCompany": "16px",
                                    "lineHeightCompany": "22px",
                                    "styleAddress": "body",
                                    "colorAddress": "#949494",
                                    "fontSizeAddress": "12px",
                                    "lineHeightAddress": "18px"
                                },
                                "Includes": {
                                    "Company": true,
                                    "Phone": true,
                                    "Website": true
                                },
                                "Style": {
                                    "paddingBottom": "6px",
                                    "textAlign": "left"
                                }
                            }
                        }
                    ],
                    [
                        {
                            "Id": "logo-default",
                            "Type": "logo",
                            "Config": {
                                "Block": {
                                    "maxWidth": "100%",
                                    "maxHeight": "75px"
                                },
                                "Style": {
                                    "textAlign": "right"
                                }
                            }
                        }
                    ]
                ]
            },
            {
                "Id": "separator-default",
                "Type": "separator",
                "Config": {
                    "Block": {
                        "color": "#e9e9e9"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                }
            },
            {
                "Id": "columnsThree-default",
                "Type": "columnsThree",
                "Config": {
                    "Block": {
                        "col1_width": "33",
                        "col2_width": "33",
                        "col3_width": "",
                        "verticalAlign": "top"
                    },
                    "Style": {
                        "paddingBottom": "20px",
                        "minHeight": "50px"
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "address-billing-default",
                            "Type": "address",
                            "Config": {
                                "Block": {
                                    "addressType": "billing",
                                    "styleHeader": "header",
                                    "fontSizeHeader": "16px",
                                    "fontWeightHeader": "bold",
                                    "lineHeightHeader": "19px",
                                    "lineSpacingHeader": "2px",
                                    "textLabelHeader": "Bill To:",
                                    "styleAddress": "body",
                                    "fontSizeAddress": "16px",
                                    "lineHeightAddress": "19px"
                                },
                                "Includes": {
                                    "HeaderLabel": true,
                                    "ContactName": true,
                                    "SpouseName": true,
                                    "Company": true,
                                    "PhoneHome": true,
                                    "PhoneMobile": true,
                                    "PhoneOther": true,
                                    "Email": true
                                },
                                "Style": {
                                    "textAlign": "left"
                                }
                            }
                        }
                    ],
                    [
                        {
                            "Id": "address-shipping-default",
                            "Type": "address",
                            "Config": {
                                "Block": {
                                    "addressType": "shipping",
                                    "styleHeader": "header",
                                    "fontSizeHeader": "16px",
                                    "fontWeightHeader": "bold",
                                    "lineHeightHeader": "19px",
                                    "lineSpacingHeader": "2px",
                                    "textLabelHeader": "Ship To:",
                                    "styleAddress": "body",
                                    "fontSizeAddress": "16px",
                                    "lineHeightAddress": "19px"
                                },
                                "Includes": {
                                    "HeaderLabel": true,
                                    "ContactName": false,
                                    "SpouseName": false,
                                    "Company": false,
                                    "PhoneHome": false,
                                    "PhoneMobile": false,
                                    "PhoneOther": false,
                                    "Email": false
                                },
                                "Style": {
                                    "textAlign": "left"
                                }
                            }
                        }
                    ],
                    [
                        {
                            "Id": "number-default",
                            "Type": "number",
                            "Config": {
                                "Block": {
                                    "displayType": "inline",
                                    "styleLabel": "header",
                                    "fontSizeLabel": "16px",
                                    "fontWeightLabel": "bold",
                                    "lineHeightLabel": "19px",
                                    "textLabel": "Invoice #",
                                    "styleValue": "header",
                                    "fontSizeValue": "16px",
                                    "fontWeightValue": "bold",
                                    "lineHeightValue": "19px",
                                    "textAlignLabel": "right",
                                    "columnWidthValue": "10%",
                                    "textAlignValue": "right",
                                    "columnSpacing": "15px"
                                },
                                "Style": {
                                    "paddingBottom": "2px",
                                    "textAlign": "right"
                                }
                            }
                        },
                        {
                            "Id": "gstTax-default",
                            "Type": "gstTax",
                            "Config": {
                                "Block": {
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "fontWeightValue": "bold",
                                    "lineHeightValue": "19px",
                                    "displayText": "Tax Invoice"
                                },
                                "Style": {
                                    "textAlign": "right"
                                }
                            }
                        },
                        {
                            "Id": "date-default",
                            "Type": "date",
                            "Config": {
                                "Block": {
                                    "displayType": "inline",
                                    "styleLabel": "body",
                                    "fontSizeLabel": "16px",
                                    "lineHeightLabel": "19px",
                                    "textLabel": "Invoice Date: ",
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "lineHeightValue": "19px",
                                    "textAlignLabel": "right",
                                    "columnWidthValue": "10%",
                                    "textAlignValue": "right",
                                    "columnSpacing": "15px"
                                },
                                "Style": {
                                    "textAlign": "right"
                                }
                            }
                        },
                        {
                            "Id": "staff-default",
                            "Type": "staff",
                            "Config": {
                                "Block": {
                                    "displayType": "inline",
                                    "styleLabel": "body",
                                    "fontSizeLabel": "16px",
                                    "lineHeightLabel": "19px",
                                    "textLabel": "Staff: ",
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "lineHeightValue": "19px",
                                    "textAlignLabel": "right",
                                    "columnWidthValue": "10%",
                                    "textAlignValue": "right",
                                    "columnSpacing": "15px"
                                },
                                "Visibility": {
                                    "Staff": true
                                },
                                "Style": {
                                    "textAlign": "right"
                                }
                            }
                        },
                        {
                            "Id": "grandTotal-meta-default",
                            "Type": "grandTotal",
                            "Config": {
                                "Block": {
                                    "displayType": "inline",
                                    "styleLabel": "body",
                                    "fontSizeLabel": "16px",
                                    "fontWeightLabel": "",
                                    "lineHeightLabel": "19px",
                                    "textLabel": "Total Amount: ",
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "fontWeightValue": "bold",
                                    "lineHeightValue": "19px",
                                    "textAlignLabel": "right",
                                    "columnWidthValue": "10%",
                                    "textAlignValue": "right",
                                    "columnSpacing": "15px"
                                },
                                "Style": {
                                    "textAlign": "right"
                                },
                                "Format": {
                                    "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                                }
                            }
                        }
                    ]
                ]
            },
            {
                "Id": "lineItems-default",
                "Type": "lineItems",
                "Config": {
                    "Block": {
                        "styleTableHeader": "header",
                        "fontSizeTableHeader": "16px",
                        "fontWeightTableHeader": "bold",
                        "lineHeightTableHeader": "29px",
                        "lineSpacingTableHeader": "10px",
                        "backgroundColorTableHeader": "#eaeaea",
                        "lineItemSpacing": "15px",
                        "columnSpacing": "10px",
                        "marginLeft": "10px",
                        "marginRight": "5px"
                    },
                    "Meta": {
                        "styleArtist": "body",
                        "fontSizeArtist": "16px",
                        "fontWeightArtist": "bold",
                        "lineHeightArtist": "19px",
                        "styleTitle": "body",
                        "fontSizeTitle": "16px",
                        "lineHeightTitle": "19px",
                        "styleMedium": "body",
                        "fontSizeMedium": "16px",
                        "lineHeightMedium": "19px",
                        "styleDimensions": "body",
                        "fontSizeDimensions": "16px",
                        "lineHeightDimensions": "19px",
                        "styleSKU": "body",
                        "fontSizeSKU": "16px",
                        "lineHeightSKU": "19px",
                        "styleQuantity": "body",
                        "fontSizeQuantity": "16px",
                        "stylePrice": "body",
                        "fontSizePrice": "16px",
                        "styleDiscount": "body",
                        "fontSizeDiscount": "16px",
                        "textZeroDiscount": "0",
                        "styleSubtotal": "body",
                        "fontSizeSubtotal": "16px"
                    },
                    "Includes": {
                        "TableHeader": true,
                        "Date": true,
                        "Medium": true,
                        "Dimensions": true,
                        "Number": false,
                        "SKU": true,
                        "Quantity": true
                    },
                    "Style": {
                        "paddingBottom": "7px"
                    },
                    "Format": {
                        "currencyFormatPriceFirst": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatDiscountFirst": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatSubtotalFirst": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatPrice": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatDiscount": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatSubtotal": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "subtotal-default",
                "Type": "subtotal",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "textLabel": "Subtotal",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "5px"
                    },
                    "Style": {
                        "paddingTop": "9px",
                        "paddingBottom": "6px",
                        "paddingRight": "5px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "discount-default",
                "Type": "discount",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "textLabel": "Discount",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "5px"
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "6px",
                        "paddingRight": "5px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "promoCodes-default",
                "Type": "promoCodes",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "rowSpacing": "11px",
                        "styleDescription": "body",
                        "fontSizeDescription": "14px",
                        "fontStyleDescription": "italic",
                        "lineHeightDescription": "19px",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "lineHeightLabel": "19px",
                        "fontWeightLabel": "bold",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "5px",
                        "fontWeightDescription": "",
                        "columnWidthLabel": "15%"
                    },
                    "Includes": {
                        "Description": true
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "6px",
                        "paddingRight": "5px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "taxes-default",
                "Type": "taxes",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "rowSpacing": "11px",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "5px"
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "6px",
                        "paddingRight": "5px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "shipping-default",
                "Type": "shipping",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "textLabel": "Shipping",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "5px"
                    },
                    "Includes": {
                        "ShippingZero": true
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "6px",
                        "paddingRight": "5px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "grandTotal-default",
                "Type": "grandTotal",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "textLabel": "Grand Total",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "fontWeightValue": "bold",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "5px"
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "6px",
                        "paddingRight": "5px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "payments-default",
                "Type": "payments",
                "Config": {
                    "Block": {
                        "styleHeader": "header",
                        "fontSizeHeader": "16px",
                        "fontWeightHeader": "bold",
                        "lineHeightHeader": "19px",
                        "lineSpacingHeader": "10px",
                        "textLabelHeader": "Payments",
                        "styleTableHeader": "header",
                        "fontSizeTableHeader": "16px",
                        "fontWeightTableHeader": "bold",
                        "lineHeightTableHeader": "19px",
                        "lineSpacingTableHeader": "10px",
                        "styleLineItem": "body",
                        "fontSizeLineItem": "16px",
                        "lineHeightLineItem": "19px",
                        "lineSpacingLineItem": "10px",
                        "methodColumnWidth": "15%",
                        "valueColumnWidth": "15%",
                        "columnSpacing": "10px",
                        "marginRight": "5px"
                    },
                    "Includes": {
                        "HeaderLabel": true,
                        "TableHeader": true,
                        "Method": true,
                        "Refunds": true
                    },
                    "Style": {
                        "paddingTop": "9px",
                        "paddingBottom": "10px"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "credits-default",
                "Type": "credits",
                "Config": {
                    "Block": {
                        "styleHeader": "header",
                        "fontSizeHeader": "16px",
                        "fontWeightHeader": "bold",
                        "lineHeightHeader": "19px",
                        "lineSpacingHeader": "10px",
                        "textLabelHeader": "Credits",
                        "styleTableHeader": "header",
                        "fontSizeTableHeader": "16px",
                        "fontWeightTableHeader": "bold",
                        "lineHeightTableHeader": "19px",
                        "lineSpacingTableHeader": "10px",
                        "styleLineItem": "body",
                        "fontSizeLineItem": "16px",
                        "lineHeightLineItem": "19px",
                        "lineSpacingLineItem": "10px",
                        "methodColumnWidth": "15%",
                        "valueColumnWidth": "15%",
                        "columnSpacing": "10px",
                        "marginRight": "5px"
                    },
                    "Includes": {
                        "HeaderLabel": true,
                        "TableHeader": true,
                        "Method": true
                    },
                    "Style": {
                        "paddingTop": "10px",
                        "paddingBottom": "10px"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "paid-default",
                "Type": "paid",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "textLabel": "Total Paid",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "fontWeightValue": "bold",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "5px"
                    },
                    "Includes": {
                        "NoPayments": true
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "6px",
                        "paddingRight": "5px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "refunded-default",
                "Type": "refunded",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "textLabel": "Total Refunded",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "fontWeightValue": "bold",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "5px"
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "6px",
                        "paddingRight": "5px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "balance-default",
                "Type": "balance",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "textLabel": "Balance",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "fontWeightValue": "bold",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "5px"
                    },
                    "Includes": {
                        "NoPayments": true
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "5px",
                        "paddingRight": "5px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "notes-default",
                "Type": "notes",
                "Config": {
                    "Block": {
                        "styleHeader": "body",
                        "fontSizeHeader": "16px",
                        "fontWeightHeader": "bold",
                        "lineHeightHeader": "19px",
                        "lineSpacingHeader": "16px",
                        "textLabelHeader": "Invoice Comments",
                        "styleNote": "body",
                        "fontSizeNote": "16px",
                        "lineHeightNote": "19px"
                    },
                    "Includes": {
                        "HeaderLabel": true
                    },
                    "Style": {
                        "paddingBottom": "16px",
                        "textAlign": "left"
                    }
                }
            },
            {
                "Id": "signature-default",
                "Type": "signature",
                "Config": {
                    "Block": {
                        "styleSignature": "body",
                        "fontSizeSignature": "16px",
                        "lineHeightSignature": "18px",
                        "labelTextSignature": "Signature:",
                        "styleDate": "body",
                        "fontSizeDate": "16px",
                        "lineHeightDate": "18px",
                        "labelTextDate": "Date:",
                        "dateWidth": "40",
                        "spacing": "80px"
                    },
                    "Includes": {
                        "Date": true
                    },
                    "Style": {
                        "paddingTop": "40px"
                    }
                }
            }
        ],
        "Migration": {
            "includeBalanceNoPayments": true,
            "includePaidNoPayments": true,
            "promoCodes": true
        }
    },
    {
        "Name": "Logo Centered",
        "IsDefault": false,
        "Type": "invoices",
        "Document": {
            "Config": {
                "Style": {
                    "paddingTop": "20px",
                    "paddingBottom": "40px",
                    "paddingLeft": "40px",
                    "paddingRight": "40px"
                },
                "PDF": {
                    "footer": true,
                    "pageMarginTop": "10",
                    "pageMarginBottom": "10",
                    "pageMarginLeft": "10",
                    "pageMarginRight": "10"
                }
            },
            "Id": "documentSettings"
        },
        "Blocks": [
            {
                "Id": "logo-default",
                "Type": "logo",
                "Config": {
                    "Block": {
                        "maxWidth": "100%",
                        "maxHeight": "75px"
                    },
                    "Style": {
                        "textAlign": "center",
                        "paddingBottom": "14px",
                        "paddingTop": "20px"
                    }
                }
            },
            {
                "Id": "separator-default",
                "Type": "separator",
                "Config": {
                    "Block": {
                        "color": "#e9e9e9"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                }
            },
            {
                "Id": "columnsThree-default",
                "Type": "columnsThree",
                "Config": {
                    "Block": {
                        "col1_width": "33",
                        "col2_width": "33",
                        "col3_width": "",
                        "verticalAlign": "top"
                    },
                    "Style": {
                        "paddingBottom": "20px",
                        "minHeight": "50px"
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "address-billing-default",
                            "Type": "address",
                            "Config": {
                                "Block": {
                                    "addressType": "billing",
                                    "styleHeader": "header",
                                    "fontSizeHeader": "16px",
                                    "fontWeightHeader": "bold",
                                    "lineHeightHeader": "19px",
                                    "lineSpacingHeader": "2px",
                                    "textLabelHeader": "Bill To:",
                                    "styleAddress": "body",
                                    "fontSizeAddress": "16px",
                                    "lineHeightAddress": "19px"
                                },
                                "Includes": {
                                    "HeaderLabel": true,
                                    "ContactName": true,
                                    "SpouseName": true,
                                    "Company": true,
                                    "PhoneHome": true,
                                    "PhoneMobile": true,
                                    "PhoneOther": true,
                                    "Email": true
                                },
                                "Style": {
                                    "textAlign": "left"
                                }
                            }
                        }
                    ],
                    [
                        {
                            "Id": "address-shipping-default",
                            "Type": "address",
                            "Config": {
                                "Block": {
                                    "addressType": "shipping",
                                    "styleHeader": "header",
                                    "fontSizeHeader": "16px",
                                    "fontWeightHeader": "bold",
                                    "lineHeightHeader": "19px",
                                    "lineSpacingHeader": "2px",
                                    "textLabelHeader": "Ship To:",
                                    "styleAddress": "body",
                                    "fontSizeAddress": "16px",
                                    "lineHeightAddress": "19px"
                                },
                                "Includes": {
                                    "HeaderLabel": true,
                                    "ContactName": false,
                                    "SpouseName": false,
                                    "Company": false,
                                    "PhoneHome": false,
                                    "PhoneMobile": false,
                                    "PhoneOther": false,
                                    "Email": false
                                },
                                "Style": {
                                    "textAlign": "left"
                                }
                            }
                        }
                    ],
                    [
                        {
                            "Id": "number-default",
                            "Type": "number",
                            "Config": {
                                "Block": {
                                    "displayType": "inline",
                                    "styleLabel": "header",
                                    "fontSizeLabel": "16px",
                                    "fontWeightLabel": "bold",
                                    "lineHeightLabel": "19px",
                                    "textLabel": "Invoice #",
                                    "styleValue": "header",
                                    "fontSizeValue": "16px",
                                    "fontWeightValue": "bold",
                                    "lineHeightValue": "19px",
                                    "textAlignLabel": "right",
                                    "columnWidthValue": "10%",
                                    "textAlignValue": "right",
                                    "columnSpacing": "15px"
                                },
                                "Style": {
                                    "paddingBottom": "2px",
                                    "textAlign": "right"
                                }
                            }
                        },
                        {
                            "Id": "gstTax-default",
                            "Type": "gstTax",
                            "Config": {
                                "Block": {
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "fontWeightValue": "bold",
                                    "lineHeightValue": "19px",
                                    "displayText": "Tax Invoice"
                                },
                                "Style": {
                                    "textAlign": "right"
                                }
                            }
                        },
                        {
                            "Id": "date-default",
                            "Type": "date",
                            "Config": {
                                "Block": {
                                    "displayType": "inline",
                                    "styleLabel": "body",
                                    "fontSizeLabel": "16px",
                                    "lineHeightLabel": "19px",
                                    "textLabel": "Invoice Date: ",
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "lineHeightValue": "19px",
                                    "textAlignLabel": "right",
                                    "columnWidthValue": "10%",
                                    "textAlignValue": "right",
                                    "columnSpacing": "15px"
                                },
                                "Style": {
                                    "textAlign": "right"
                                }
                            }
                        },
                        {
                            "Id": "staff-default",
                            "Type": "staff",
                            "Config": {
                                "Block": {
                                    "displayType": "inline",
                                    "styleLabel": "body",
                                    "fontSizeLabel": "16px",
                                    "lineHeightLabel": "19px",
                                    "textLabel": "Staff: ",
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "lineHeightValue": "19px",
                                    "textAlignLabel": "right",
                                    "columnWidthValue": "10%",
                                    "textAlignValue": "right",
                                    "columnSpacing": "15px"
                                },
                                "Visibility": {
                                    "Staff": true
                                },
                                "Style": {
                                    "textAlign": "right"
                                }
                            }
                        },
                        {
                            "Id": "grandTotal-meta-default",
                            "Type": "grandTotal",
                            "Config": {
                                "Block": {
                                    "displayType": "inline",
                                    "styleLabel": "body",
                                    "fontSizeLabel": "16px",
                                    "fontWeightLabel": "",
                                    "lineHeightLabel": "19px",
                                    "textLabel": "Total Amount: ",
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "fontWeightValue": "bold",
                                    "lineHeightValue": "19px",
                                    "textAlignLabel": "right",
                                    "columnWidthValue": "10%",
                                    "textAlignValue": "right",
                                    "columnSpacing": "15px"
                                },
                                "Style": {
                                    "textAlign": "right"
                                },
                                "Format": {
                                    "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                                }
                            }
                        }
                    ]
                ]
            },
            {
                "Id": "lineItems-default",
                "Type": "lineItems",
                "Config": {
                    "Block": {
                        "styleTableHeader": "header",
                        "fontSizeTableHeader": "16px",
                        "fontWeightTableHeader": "bold",
                        "lineHeightTableHeader": "29px",
                        "lineSpacingTableHeader": "10px",
                        "backgroundColorTableHeader": "#eaeaea",
                        "lineItemSpacing": "15px",
                        "columnSpacing": "10px",
                        "marginLeft": "10px",
                        "marginRight": "5px"
                    },
                    "Meta": {
                        "styleArtist": "body",
                        "fontSizeArtist": "16px",
                        "fontWeightArtist": "bold",
                        "lineHeightArtist": "19px",
                        "styleTitle": "body",
                        "fontSizeTitle": "16px",
                        "lineHeightTitle": "19px",
                        "styleMedium": "body",
                        "fontSizeMedium": "16px",
                        "lineHeightMedium": "19px",
                        "styleDimensions": "body",
                        "fontSizeDimensions": "16px",
                        "lineHeightDimensions": "19px",
                        "styleSKU": "body",
                        "fontSizeSKU": "16px",
                        "lineHeightSKU": "19px",
                        "styleQuantity": "body",
                        "fontSizeQuantity": "16px",
                        "stylePrice": "body",
                        "fontSizePrice": "16px",
                        "styleDiscount": "body",
                        "fontSizeDiscount": "16px",
                        "textZeroDiscount": "0",
                        "styleSubtotal": "body",
                        "fontSizeSubtotal": "16px"
                    },
                    "Includes": {
                        "TableHeader": true,
                        "Date": true,
                        "Medium": true,
                        "Dimensions": true,
                        "Number": false,
                        "SKU": true,
                        "Quantity": true
                    },
                    "Style": {
                        "paddingBottom": "7px"
                    },
                    "Format": {
                        "currencyFormatPriceFirst": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatDiscountFirst": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatSubtotalFirst": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatPrice": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatDiscount": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatSubtotal": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "subtotal-default",
                "Type": "subtotal",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "textLabel": "Subtotal",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "5px"
                    },
                    "Style": {
                        "paddingTop": "9px",
                        "paddingBottom": "6px",
                        "paddingRight": "5px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "discount-default",
                "Type": "discount",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "textLabel": "Discount",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "5px"
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "6px",
                        "paddingRight": "5px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "promoCodes-default",
                "Type": "promoCodes",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "rowSpacing": "11px",
                        "styleDescription": "body",
                        "fontSizeDescription": "14px",
                        "fontStyleDescription": "italic",
                        "lineHeightDescription": "19px",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "lineHeightLabel": "19px",
                        "fontWeightLabel": "bold",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "5px",
                        "fontWeightDescription": "",
                        "columnWidthLabel": "15%"
                    },
                    "Includes": {
                        "Description": true
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "6px",
                        "paddingRight": "5px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "taxes-default",
                "Type": "taxes",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "rowSpacing": "11px",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "5px"
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "6px",
                        "paddingRight": "5px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "shipping-default",
                "Type": "shipping",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "textLabel": "Shipping",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "5px"
                    },
                    "Includes": {
                        "ShippingZero": true
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "6px",
                        "paddingRight": "5px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "grandTotal-default",
                "Type": "grandTotal",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "textLabel": "Grand Total",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "fontWeightValue": "bold",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "5px"
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "6px",
                        "paddingRight": "5px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "payments-default",
                "Type": "payments",
                "Config": {
                    "Block": {
                        "styleHeader": "header",
                        "fontSizeHeader": "16px",
                        "fontWeightHeader": "bold",
                        "lineHeightHeader": "19px",
                        "lineSpacingHeader": "10px",
                        "textLabelHeader": "Payments",
                        "styleTableHeader": "header",
                        "fontSizeTableHeader": "16px",
                        "fontWeightTableHeader": "bold",
                        "lineHeightTableHeader": "19px",
                        "lineSpacingTableHeader": "10px",
                        "styleLineItem": "body",
                        "fontSizeLineItem": "16px",
                        "lineHeightLineItem": "19px",
                        "lineSpacingLineItem": "10px",
                        "methodColumnWidth": "15%",
                        "valueColumnWidth": "15%",
                        "columnSpacing": "10px",
                        "marginRight": "5px"
                    },
                    "Includes": {
                        "HeaderLabel": true,
                        "TableHeader": true,
                        "Method": true,
                        "Refunds": true
                    },
                    "Style": {
                        "paddingTop": "9px",
                        "paddingBottom": "10px"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "credits-default",
                "Type": "credits",
                "Config": {
                    "Block": {
                        "styleHeader": "header",
                        "fontSizeHeader": "16px",
                        "fontWeightHeader": "bold",
                        "lineHeightHeader": "19px",
                        "lineSpacingHeader": "10px",
                        "textLabelHeader": "Credits",
                        "styleTableHeader": "header",
                        "fontSizeTableHeader": "16px",
                        "fontWeightTableHeader": "bold",
                        "lineHeightTableHeader": "19px",
                        "lineSpacingTableHeader": "10px",
                        "styleLineItem": "body",
                        "fontSizeLineItem": "16px",
                        "lineHeightLineItem": "19px",
                        "lineSpacingLineItem": "10px",
                        "methodColumnWidth": "15%",
                        "valueColumnWidth": "15%",
                        "columnSpacing": "10px",
                        "marginRight": "5px"
                    },
                    "Includes": {
                        "HeaderLabel": true,
                        "TableHeader": true,
                        "Method": true
                    },
                    "Style": {
                        "paddingTop": "10px",
                        "paddingBottom": "10px"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "paid-default",
                "Type": "paid",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "textLabel": "Total Paid",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "fontWeightValue": "bold",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "5px"
                    },
                    "Includes": {
                        "NoPayments": true
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "6px",
                        "paddingRight": "5px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "refunded-default",
                "Type": "refunded",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "textLabel": "Total Refunded",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "fontWeightValue": "bold",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "5px"
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "6px",
                        "paddingRight": "5px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "balance-default",
                "Type": "balance",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "textLabel": "Balance",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "fontWeightValue": "bold",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "5px"
                    },
                    "Includes": {
                        "NoPayments": true
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "5px",
                        "paddingRight": "5px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "notes-default",
                "Type": "notes",
                "Config": {
                    "Block": {
                        "styleHeader": "body",
                        "fontSizeHeader": "16px",
                        "fontWeightHeader": "bold",
                        "lineHeightHeader": "19px",
                        "lineSpacingHeader": "16px",
                        "textLabelHeader": "Invoice Comments",
                        "styleNote": "body",
                        "fontSizeNote": "16px",
                        "lineHeightNote": "19px"
                    },
                    "Includes": {
                        "HeaderLabel": true
                    },
                    "Style": {
                        "paddingBottom": "16px",
                        "textAlign": "left"
                    }
                }
            },
            {
                "Id": "signature-default",
                "Type": "signature",
                "Config": {
                    "Block": {
                        "styleSignature": "body",
                        "fontSizeSignature": "16px",
                        "lineHeightSignature": "18px",
                        "labelTextSignature": "Signature:",
                        "styleDate": "body",
                        "fontSizeDate": "16px",
                        "lineHeightDate": "18px",
                        "labelTextDate": "Date:",
                        "dateWidth": "40",
                        "spacing": "80px"
                    },
                    "Includes": {
                        "Date": true
                    },
                    "Style": {
                        "paddingTop": "40px"
                    }
                }
            }
        ],
        "Migration": {
            "includeBalanceNoPayments": true,
            "includePaidNoPayments": true,
            "promoCodes": true
        }
    },
    {
        "Name": "Classic",
        "IsDefault": true,
        "Type": "invoices",
        "Document": {
            "Config": {
                "Style": {
                    "paddingTop": "20px",
                    "paddingBottom": "40px",
                    "paddingLeft": "40px",
                    "paddingRight": "40px"
                },
                "PDF": {
                    "footer": true,
                    "pageMarginTop": "10",
                    "pageMarginBottom": "10",
                    "pageMarginLeft": "10",
                    "pageMarginRight": "10"
                }
            },
            "Id": "documentSettings"
        },
        "Blocks": [
            {
                "Id": "logo-default",
                "Type": "logo",
                "Config": {
                    "Block": {
                        "maxWidth": "200px",
                        "maxHeight": "150px"
                    },
                    "Style": {
                        "textAlign": "center",
                        "paddingBottom": "34px"
                    }
                }
            },
            {
                "Id": "columnsThree-default",
                "Type": "columnsThree",
                "Config": {
                    "Block": {
                        "col1_width": "33",
                        "col2_width": "33",
                        "col3_width": "",
                        "verticalAlign": "top"
                    },
                    "Style": {
                        "paddingBottom": "5px",
                        "minHeight": "50px"
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "address-billing-default",
                            "Type": "address",
                            "Config": {
                                "Block": {
                                    "addressType": "billing",
                                    "styleHeader": "header",
                                    "fontSizeHeader": "16px",
                                    "fontWeightHeader": "bold",
                                    "lineHeightHeader": "19px",
                                    "lineSpacingHeader": "",
                                    "textLabelHeader": "Bill To:",
                                    "styleAddress": "body",
                                    "fontSizeAddress": "16px",
                                    "lineHeightAddress": "19px"
                                },
                                "Includes": {
                                    "HeaderLabel": true,
                                    "ContactName": true,
                                    "SpouseName": true,
                                    "Company": true,
                                    "PhoneHome": true,
                                    "PhoneMobile": true,
                                    "PhoneOther": true,
                                    "Email": true
                                },
                                "Style": {
                                    "textAlign": "left"
                                }
                            }
                        }
                    ],
                    [
                        {
                            "Id": "address-shipping-default",
                            "Type": "address",
                            "Config": {
                                "Block": {
                                    "addressType": "shipping",
                                    "styleHeader": "header",
                                    "fontSizeHeader": "16px",
                                    "fontWeightHeader": "bold",
                                    "lineHeightHeader": "19px",
                                    "lineSpacingHeader": "",
                                    "textLabelHeader": "Ship To:",
                                    "styleAddress": "body",
                                    "fontSizeAddress": "16px",
                                    "lineHeightAddress": "19px"
                                },
                                "Includes": {
                                    "HeaderLabel": true,
                                    "ContactName": false,
                                    "SpouseName": false,
                                    "Company": false,
                                    "PhoneHome": false,
                                    "PhoneMobile": false,
                                    "PhoneOther": false,
                                    "Email": false
                                },
                                "Style": {
                                    "textAlign": "left"
                                }
                            }
                        }
                    ],
                    [
                        {
                            "Id": "number-default",
                            "Type": "number",
                            "Config": {
                                "Block": {
                                    "displayType": "inline",
                                    "styleLabel": "header",
                                    "fontSizeLabel": "16px",
                                    "fontWeightLabel": "bold",
                                    "lineHeightLabel": "19px",
                                    "textLabel": "Invoice #",
                                    "styleValue": "header",
                                    "fontSizeValue": "16px",
                                    "fontWeightValue": "bold",
                                    "lineHeightValue": "19px",
                                    "textAlignLabel": "right",
                                    "columnWidthValue": "10%",
                                    "textAlignValue": "right",
                                    "columnSpacing": "15px"
                                },
                                "Style": {
                                    "paddingBottom": "2px",
                                    "textAlign": "right"
                                }
                            }
                        },
                        {
                            "Id": "gstTax-default",
                            "Type": "gstTax",
                            "Config": {
                                "Block": {
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "fontWeightValue": "bold",
                                    "lineHeightValue": "19px",
                                    "displayText": "Tax Invoice"
                                },
                                "Style": {
                                    "textAlign": "right"
                                }
                            }
                        },
                        {
                            "Id": "date-default",
                            "Type": "date",
                            "Config": {
                                "Block": {
                                    "displayType": "inline",
                                    "styleLabel": "body",
                                    "fontSizeLabel": "16px",
                                    "lineHeightLabel": "19px",
                                    "textLabel": "Invoice Date: ",
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "lineHeightValue": "19px",
                                    "textAlignLabel": "right",
                                    "columnWidthValue": "10%",
                                    "textAlignValue": "right",
                                    "columnSpacing": "15px"
                                },
                                "Style": {
                                    "textAlign": "right"
                                }
                            }
                        },
                        {
                            "Id": "staff-default",
                            "Type": "staff",
                            "Config": {
                                "Block": {
                                    "displayType": "inline",
                                    "styleLabel": "body",
                                    "fontSizeLabel": "16px",
                                    "lineHeightLabel": "19px",
                                    "textLabel": "Staff: ",
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "lineHeightValue": "19px",
                                    "textAlignLabel": "right",
                                    "columnWidthValue": "10%",
                                    "textAlignValue": "right",
                                    "columnSpacing": "15px"
                                },
                                "Visibility": {
                                    "Staff": true
                                },
                                "Style": {
                                    "textAlign": "right"
                                }
                            }
                        },
                        {
                            "Id": "grandTotal-meta-default",
                            "Type": "grandTotal",
                            "Config": {
                                "Block": {
                                    "displayType": "inline",
                                    "styleLabel": "body",
                                    "fontSizeLabel": "16px",
                                    "fontWeightLabel": "",
                                    "lineHeightLabel": "19px",
                                    "textLabel": "Total Amount: ",
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "fontWeightValue": "bold",
                                    "lineHeightValue": "19px",
                                    "textAlignLabel": "right",
                                    "columnWidthValue": "10%",
                                    "textAlignValue": "right",
                                    "columnSpacing": "15px"
                                },
                                "Style": {
                                    "textAlign": "right"
                                },
                                "Format": {
                                    "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                                }
                            }
                        }
                    ]
                ]
            },
            {
                "Id": "lineItems-default",
                "Type": "lineItems",
                "Config": {
                    "Block": {
                        "styleTableHeader": "header",
                        "fontSizeTableHeader": "16px",
                        "fontWeightTableHeader": "bold",
                        "lineHeightTableHeader": "29px",
                        "lineSpacingTableHeader": "10px",
                        "backgroundColorTableHeader": "#eaeaea",
                        "lineItemSpacing": "20px",
                        "columnSpacing": "15px",
                        "marginLeft": "",
                        "marginRight": ""
                    },
                    "Meta": {
                        "styleArtist": "body",
                        "fontSizeArtist": "16px",
                        "fontWeightArtist": "bold",
                        "lineHeightArtist": "19px",
                        "styleTitle": "body",
                        "fontSizeTitle": "16px",
                        "lineHeightTitle": "19px",
                        "styleMedium": "body",
                        "fontSizeMedium": "16px",
                        "lineHeightMedium": "19px",
                        "styleDimensions": "body",
                        "fontSizeDimensions": "16px",
                        "lineHeightDimensions": "19px",
                        "styleSKU": "body",
                        "fontSizeSKU": "16px",
                        "lineHeightSKU": "19px",
                        "styleQuantity": "body",
                        "fontSizeQuantity": "16px",
                        "stylePrice": "body",
                        "fontSizePrice": "16px",
                        "styleDiscount": "body",
                        "fontSizeDiscount": "16px",
                        "textZeroDiscount": "0",
                        "styleSubtotal": "body",
                        "fontSizeSubtotal": "16px"
                    },
                    "Includes": {
                        "TableHeader": true,
                        "Date": true,
                        "Medium": true,
                        "Dimensions": true,
                        "Number": false,
                        "SKU": true,
                        "Quantity": true
                    },
                    "Style": {
                        "paddingBottom": ""
                    },
                    "Format": {
                        "currencyFormatPriceFirst": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatDiscountFirst": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatSubtotalFirst": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatPrice": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatDiscount": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatSubtotal": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "subtotal-default",
                "Type": "subtotal",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "textLabel": "Subtotal",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "15px"
                    },
                    "Style": {
                        "paddingTop": "18px",
                        "paddingBottom": "6px",
                        "paddingRight": "",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "discount-default",
                "Type": "discount",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "textLabel": "Discount",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "15px"
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "6px",
                        "paddingRight": "",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "promoCodes-default",
                "Type": "promoCodes",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleDescription": "body",
                        "fontSizeDescription": "14px",
                        "lineHeightDescription": "19px",
                        "fontStyleDescription": "italic",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "lineHeightLabel": "19px",
                        "fontWeightLabel": "bold",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "columnWidthLabel": "15%",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "15px"
                    },
                    "Includes": {
                        "Description": true
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "6px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "taxes-default",
                "Type": "taxes",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "rowSpacing": "11px",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "15px"
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "6px",
                        "paddingRight": "",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "shipping-default",
                "Type": "shipping",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "textLabel": "Shipping",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "15px"
                    },
                    "Includes": {
                        "ShippingZero": true
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "6px",
                        "paddingRight": "",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "grandTotal-default",
                "Type": "grandTotal",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "textLabel": "Grand Total",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "fontWeightValue": "bold",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "15px"
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "6px",
                        "paddingRight": "",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "payments-default",
                "Type": "payments",
                "Config": {
                    "Block": {
                        "styleHeader": "header",
                        "fontSizeHeader": "16px",
                        "fontWeightHeader": "bold",
                        "lineHeightHeader": "19px",
                        "lineSpacingHeader": "10px",
                        "textLabelHeader": "Payments",
                        "styleTableHeader": "header",
                        "fontSizeTableHeader": "16px",
                        "fontWeightTableHeader": "bold",
                        "lineHeightTableHeader": "19px",
                        "lineSpacingTableHeader": "10px",
                        "styleLineItem": "body",
                        "fontSizeLineItem": "16px",
                        "lineHeightLineItem": "19px",
                        "lineSpacingLineItem": "10px",
                        "methodColumnWidth": "15%",
                        "valueColumnWidth": "10%",
                        "columnSpacing": "15px",
                        "marginRight": ""
                    },
                    "Includes": {
                        "HeaderLabel": true,
                        "TableHeader": true,
                        "Method": true,
                        "Refunds": true
                    },
                    "Style": {
                        "paddingTop": "9px",
                        "paddingBottom": "11px"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "credits-default",
                "Type": "credits",
                "Config": {
                    "Block": {
                        "styleHeader": "header",
                        "fontSizeHeader": "16px",
                        "fontWeightHeader": "bold",
                        "lineHeightHeader": "19px",
                        "lineSpacingHeader": "10px",
                        "textLabelHeader": "Credits",
                        "styleTableHeader": "header",
                        "fontSizeTableHeader": "16px",
                        "fontWeightTableHeader": "bold",
                        "lineHeightTableHeader": "19px",
                        "lineSpacingTableHeader": "10px",
                        "styleLineItem": "body",
                        "fontSizeLineItem": "16px",
                        "lineHeightLineItem": "19px",
                        "lineSpacingLineItem": "10px",
                        "methodColumnWidth": "15%",
                        "valueColumnWidth": "10%",
                        "columnSpacing": "15px",
                        "marginRight": ""
                    },
                    "Includes": {
                        "HeaderLabel": true,
                        "TableHeader": true,
                        "Method": true
                    },
                    "Style": {
                        "paddingTop": "9px",
                        "paddingBottom": "9px"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "paid-default",
                "Type": "paid",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "textLabel": "Total Paid",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "fontWeightValue": "bold",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "15px"
                    },
                    "Includes": {
                        "NoPayments": true
                    },
                    "Style": {
                        "paddingTop": "6px",
                        "paddingBottom": "6px",
                        "paddingRight": "",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "refunded-default",
                "Type": "refunded",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "textLabel": "Total Refunded",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "fontWeightValue": "bold",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "15px"
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "6px",
                        "paddingRight": "",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "balance-default",
                "Type": "balance",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "fontWeightLabel": "bold",
                        "lineHeightLabel": "19px",
                        "textLabel": "Balance",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "fontWeightValue": "bold",
                        "lineHeightValue": "19px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "columnSpacing": "15px"
                    },
                    "Includes": {
                        "NoPayments": true
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "5px",
                        "paddingRight": "",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "notes-default",
                "Type": "notes",
                "Config": {
                    "Block": {
                        "styleHeader": "body",
                        "fontSizeHeader": "16px",
                        "fontWeightHeader": "bold",
                        "lineHeightHeader": "19px",
                        "lineSpacingHeader": "16px",
                        "textLabelHeader": "Invoice Comments",
                        "styleNote": "body",
                        "fontSizeNote": "16px",
                        "lineHeightNote": "19px"
                    },
                    "Includes": {
                        "HeaderLabel": true
                    },
                    "Style": {
                        "paddingBottom": "16px",
                        "textAlign": "left"
                    }
                }
            },
            {
                "Id": "signature-default",
                "Type": "signature",
                "Config": {
                    "Block": {
                        "styleSignature": "body",
                        "fontSizeSignature": "16px",
                        "lineHeightSignature": "18px",
                        "labelTextSignature": "Signature:",
                        "styleDate": "body",
                        "fontSizeDate": "16px",
                        "lineHeightDate": "18px",
                        "labelTextDate": "Date:",
                        "dateWidth": "40",
                        "spacing": "80px"
                    },
                    "Includes": {
                        "Date": true
                    },
                    "Style": {
                        "paddingTop": "40px"
                    }
                }
            }
        ],
        "Migration": {
            "includeBalanceNoPayments": true,
            "includePaidNoPayments": true,
            "promoCodes": true
        }
    },
    /*
    {
        "Name": "Contemporary",
        "IsDefault": false,
        "Type": "invoices",
        "Document": {
            "Config": {
                "Style": {
                    "paddingTop": "20px",
                    "paddingBottom": "40px",
                    "paddingLeft": "40px",
                    "paddingRight": "40px"
                },
                "PDF": {
                    "footer": true,
                    "pageMarginTop": "35",
                    "pageMarginBottom": "35",
                    "pageMarginLeft": "10",
                    "pageMarginRight": "10"
                }
            },
            "Id": "documentSettings"
        },
        "Blocks": [
            {
                "Id": "logo-default",
                "Type": "logo",
                "Config": {
                    "Block": {
                        "maxWidth": "430px"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px",
                        "textAlign": "center"
                    }
                }
            },
            {
                "Id": "gstTax-default",
                "Type": "gstTax",
                "Config": {
                    "Block": {
                        "styleValue": "body",
                        "fontSizeValue": "18px",
                        "fontWeightValue": "",
                        "lineHeightValue": "27px",
                        "displayText": "Tax Invoice"
                    },
                    "Style": {
                        "paddingTop": "14px",
                        "paddingBottom": "",
                        "textAlign": "left"
                    }
                }
            },
            {
                "Id": "date-default",
                "Type": "date",
                "Config": {
                    "Block": {
                        "displayType": "inline",
                        "styleLabel": "body",
                        "fontSizeLabel": "16px",
                        "lineHeightLabel": "19px",
                        "textLabel": "",
                        "styleValue": "body",
                        "fontSizeValue": "18px",
                        "lineHeightValue": "27px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "10%",
                        "textAlignValue": "right",
                        "columnSpacing": "15px"
                    },
                    "Style": {
                        "paddingBottom": "40px",
                        "textAlign": "left"
                    }
                }
            },
            {
                "Id": "columnsThree-default",
                "Type": "columnsThree",
                "Config": {
                    "Block": {
                        "col1_width": "34",
                        "col2_width": "3",
                        "col3_width": "63",
                        "verticalAlign": "top"
                    },
                    "Style": {
                        "paddingBottom": "60px",
                        "minHeight": "50px"
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "address-billing-default",
                            "Type": "address",
                            "Config": {
                                "Block": {
                                    "addressType": "billing",
                                    "styleHeader": "header",
                                    "fontSizeHeader": "16px",
                                    "fontWeightHeader": "bold",
                                    "lineHeightHeader": "19px",
                                    "textLabelHeader": "Bill To:",
                                    "styleAddress": "body",
                                    "fontSizeAddress": "18px",
                                    "lineHeightAddress": "27px"
                                },
                                "Includes": {
                                    "HeaderLabel": false,
                                    "ContactName": true,
                                    "SpouseName": true,
                                    "Company": true,
                                    "PhoneHome": true,
                                    "PhoneMobile": true,
                                    "PhoneOther": true,
                                    "Email": true
                                },
                                "Style": {
                                    "paddingRight": "3%",
                                    "textAlign": "left"
                                }
                            }
                        }
                    ],
                    [],
                    [
                        {
                            "Id": "address-shipping-default",
                            "Type": "address",
                            "Config": {
                                "Block": {
                                    "addressType": "shipping",
                                    "styleHeader": "header",
                                    "fontSizeHeader": "18px",
                                    "fontWeightHeader": "bold",
                                    "lineHeightHeader": "27px",
                                    "textLabelHeader": "Shipping",
                                    "styleAddress": "body",
                                    "fontSizeAddress": "18px",
                                    "lineHeightAddress": "27px"
                                },
                                "Includes": {
                                    "HeaderLabel": true,
                                    "ContactName": false,
                                    "SpouseName": false,
                                    "Company": false,
                                    "PhoneHome": false,
                                    "PhoneMobile": false,
                                    "PhoneOther": false,
                                    "Email": false
                                },
                                "Style": {
                                    "textAlign": "left"
                                }
                            }
                        }
                    ]
                ]
            },
            {
                "Id": "number-default",
                "Type": "number",
                "Config": {
                    "Block": {
                        "displayType": "inline",
                        "styleLabel": "header",
                        "fontSizeLabel": "18px",
                        "fontWeightLabel": "",
                        "lineHeightLabel": "27px",
                        "textLabel": "Invoice No. ",
                        "styleValue": "header",
                        "fontSizeValue": "18px",
                        "fontWeightValue": "",
                        "lineHeightValue": "27px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "10%",
                        "textAlignValue": "right",
                        "columnSpacing": "15px"
                    },
                    "Style": {
                        "paddingTop": "10px",
                        "paddingBottom": "10px",
                        "paddingLeft": "4px",
                        "textAlign": "left"
                    }
                }
            },
            {
                "Id": "lineItems-default",
                "Type": "lineItems",
                "Config": {
                    "Block": {
                        "styleTableHeader": "header",
                        "fontSizeTableHeader": "16px",
                        "fontWeightTableHeader": "bold",
                        "lineHeightTableHeader": "30px",
                        "backgroundColorTableHeader": "#eaeaea",
                        "lineItemSpacing": "20px",
                        "columnSpacing": "20px",
                        "marginLeft": "",
                        "marginRight": "",
                        "borderTop": "1px solid #999",
                        "borderTopSpacing": "10px",
                        "borderBottom": "1px solid #999",
                        "borderBottomSpacing": "10px"
                    },
                    "Meta": {
                        "styleArtist": "body",
                        "fontSizeArtist": "16px",
                        "fontWeightArtist": "",
                        "lineHeightArtist": "19px",
                        "styleTitle": "body",
                        "fontSizeTitle": "16px",
                        "lineHeightTitle": "19px",
                        "marginLeftTitle": "40px",
                        "styleMedium": "body",
                        "fontSizeMedium": "16px",
                        "lineHeightMedium": "19px",
                        "marginLeftMedium": "40px",
                        "styleDimensions": "body",
                        "fontSizeDimensions": "16px",
                        "lineHeightDimensions": "19px",
                        "marginLeftDimensions": "40px",
                        "styleSKU": "body",
                        "fontSizeSKU": "16px",
                        "lineHeightSKU": "19px",
                        "marginLeftSKU": "40px",
                        "styleQuantity": "body",
                        "fontSizeQuantity": "16px",
                        "stylePrice": "body",
                        "fontSizePrice": "16px",
                        "styleDiscount": "body",
                        "fontSizeDiscount": "16px",
                        "textZeroDiscount": "0",
                        "styleSubtotal": "body",
                        "fontSizeSubtotal": "16px"
                    },
                    "Includes": {
                        "TableHeader": false,
                        "Date": false,
                        "Medium": true,
                        "Dimensions": false,
                        "Number": false,
                        "SKU": false,
                        "Quantity": false
                    },
                    "Style": {},
                    "Format": {
                        "currencyFormatPriceFirst": "[CurrencySymbol]  1[ThousandsSep]000",
                        "currencyFormatDiscountFirst": "[CurrencySymbol]  1[ThousandsSep]000",
                        "currencyFormatSubtotalFirst": "[CurrencySymbol]  1[ThousandsSep]000",
                        "currencyFormatPrice": "1[ThousandsSep]000",
                        "currencyFormatDiscount": "1[ThousandsSep]000",
                        "currencyFormatSubtotal": "1[ThousandsSep]000"
                    }
                }
            },
            {
                "Id": "subtotal-default",
                "Type": "subtotal",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "lineHeightLabel": "16px",
                        "textLabel": "Subtotal",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "16px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "17%",
                        "textAlignValue": "right",
                        "columnSpacing": "15px"
                    },
                    "Style": {
                        "paddingTop": "7px",
                        "paddingBottom": "2px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]  1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "discount-default",
                "Type": "discount",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "lineHeightLabel": "16px",
                        "textLabel": "Discount",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "16px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "17%",
                        "textAlignValue": "right",
                        "columnSpacing": "15px"
                    },
                    "Style": {
                        "paddingBottom": "2px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "promoCodes-default",
                "Type": "promoCodes",
                "Config": {
                  "Block": {
                    "displayType": "columns",
                    "styleDescription": "body",
                    "fontSizeDescription": "14px",
                    "lineHeightDescription": "16px",
                    "fontStyleDescription": "italic",
                    "styleLabel": "header",
                    "fontSizeLabel": "16px",
                    "lineHeightLabel": "16px",
                    "styleValue": "body",
                    "fontSizeValue": "16px",
                    "lineHeightValue": "16px",
                    "columnWidthLabel": "17%",
                    "textAlignLabel": "right",
                    "columnWidthValue": "17%",
                    "textAlignValue": "right",
                    "columnSpacing": "15px"
                  },
                  "Includes": {
                    "Description": true
                  },
                  "Style": {
                    "paddingBottom": "2px",
                    "textAlign": "right"
                  },
                  "Format": {
                    "currencyFormat": "1[ThousandsSep]000[DecimalSep]00"
                  }
                }
              },
            {
                "Id": "taxes-default",
                "Type": "taxes",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "rowSpacing": "2px",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "lineHeightLabel": "16px",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "16px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "17%",
                        "textAlignValue": "right",
                        "columnSpacing": "15px"
                    },
                    "Style": {
                        "paddingBottom": "2px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "shipping-default",
                "Type": "shipping",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "lineHeightLabel": "16px",
                        "textLabel": "Shipping",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "16px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "17%",
                        "textAlignValue": "right",
                        "columnSpacing": "15px"
                    },
                    "Includes": {
                        "ShippingZero": false
                    },
                    "Style": {
                        "paddingBottom": "2px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "grandTotal-default",
                "Type": "grandTotal",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "lineHeightLabel": "16px",
                        "textLabel": "Total Amount Due",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "16px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "17%",
                        "textAlignValue": "right",
                        "columnSpacing": "15px"
                    },
                    "Style": {
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]  1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "columnsTwo-default",
                "Type": "columnsTwo",
                "Config": {
                    "Block": {
                        "col1_width": "50",
                        "col2_width": "50",
                        "verticalAlign": "top"
                    },
                    "Style": {
                        "minHeight": "0px"
                    }
                },
                "Columns": [
                    [],
                    [
                        {
                            "Id": "payments-default",
                            "Type": "payments",
                            "Config": {
                                "Block": {
                                    "styleHeader": "header",
                                    "fontSizeHeader": "16px",
                                    "fontWeightHeader": "bold",
                                    "lineHeightHeader": "19px",
                                    "lineSpacingHeader": "5px",
                                    "textLabelHeader": "Payments",
                                    "styleTableHeader": "header",
                                    "fontSizeTableHeader": "16px",
                                    "fontWeightTableHeader": "bold",
                                    "lineHeightTableHeader": "19px",
                                    "styleLineItem": "body",
                                    "fontSizeLineItem": "16px",
                                    "lineHeightLineItem": "19px",
                                    "lineSpacingLineItem": "10px",
                                    "methodColumnWidth": "15%",
                                    "valueColumnWidth": "25%",
                                    "columnSpacing": "15px",
                                    "borderTop": "1px solid #999",
                                    "borderTopSpacing": "5px",
                                    "borderBottom": "1px solid #999",
                                    "borderBottomSpacing": "5px"
                                },
                                "Includes": {
                                    "HeaderLabel": true,
                                    "TableHeader": false,
                                    "Method": true,
                                    "Refunds": true
                                },
                                "Style": {
                                    "paddingTop": "45px",
                                    "paddingBottom": "4px"
                                },
                                "Format": {
                                    "currencyFormat": "1[ThousandsSep]000[DecimalSep]00"
                                }
                            }
                        }
                    ]
                ]
            },
            {
                "Id": "paid-default",
                "Type": "paid",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "lineHeightLabel": "16px",
                        "textLabel": "Total Paid",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "16px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "17%",
                        "textAlignValue": "right",
                        "columnSpacing": "15px"
                    },
                    "Includes": {
                        "NoPayments": false
                    },
                    "Style": {
                        "paddingTop": "2px",
                        "paddingBottom": "2px",
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "balance-default",
                "Type": "balance",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "lineHeightLabel": "16px",
                        "textLabel": "Balance",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "16px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "17%",
                        "textAlignValue": "right",
                        "columnSpacing": "15px"
                    },
                    "Includes": {
                        "NoPayments": false
                    },
                    "Style": {
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]  1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "notes-default",
                "Type": "notes",
                "Config": {
                    "Block": {
                        "styleHeader": "body",
                        "fontSizeHeader": "16px",
                        "fontWeightHeader": "bold",
                        "lineHeightHeader": "19px",
                        "textLabelHeader": "Invoice Comments",
                        "styleNote": "body",
                        "fontSizeNote": "16px",
                        "lineHeightNote": "19px"
                    },
                    "Includes": {
                        "HeaderLabel": false
                    },
                    "Style": {
                        "paddingTop": "56px",
                        "textAlign": "left"
                    }
                }
            }
        ],
        "Migration": {
            "includeBalanceNoPayments": true,
            "includePaidNoPayments": true,
            "promoCodes": true
        }
    }
    */
];

module.exports = Templates;